module.exports = __webpack_public_path__ + "img/1F1F8-1F1F3.fc599332.svg";